import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Input} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';

import ErrorMsg from "../common/ErrorMsg";
import StaffDataService from "../../services/StaffDataService";
import LoadingModal from "../common/LoadingModal";
import FormValidator from "../../validations/FormValidator";
import {ValidationRules} from "./ValidationRules";


export default class MessageModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            userMasterList: [],
            selectedMsg: {
                id: 0,
                message_category: 0,
                message: ''
            },
            messageToBeSent: {
                user_list: [],
                user: 0,
                message: '',
            },
            isAddClicked: false,
            isEditClicked: false,
            selectAll: false,
            categoryList: [],
            errors: {},
            userList: {}
        };
        this.validator = new FormValidator(ValidationRules);
    }

    componentDidMount = () => {
        if (this.props.selectedUser.id > 0 && this.props.agencyLocation) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        try {
            await this.props.getMessageList(this.props.agencyLocation);
            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        this.getUserListToSendMesasage();
        let selectedUser = {...this.props.selectedUser};
        let userList = {};
        userList[selectedUser.id] = true;
        this.setState({userList});
    };

    getUserListToSendMesasage = async () => {
        try {
            // call action
            let users = await this.props.getUserListToSendMesasage();
            if (users) {
                this.setState({userMasterList: [...users]})
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    }

    msgChangeHandler = (event) => {
        if (event.currentTarget.value > 0) {
            if (!(isEmpty(this.props.staffData))) {
                const {messages} = this.props.staffData;
                let messageToBeSent = {...this.state.messageToBeSent};
                let selectedMsg = {};                
                messages.map(msg => {
                    if(msg.id === parseInt(event.currentTarget.value)) {
                        selectedMsg = {...msg};
                    }
                });
                messageToBeSent['message'] = selectedMsg.message;
                this.setState({selectedMsg, messageToBeSent});
            }
        }
    };

    msgTextChangeHandler = (event) => {
        let value = event.currentTarget.value;
        let messageToBeSent = {...this.state.messageToBeSent};
        messageToBeSent['message'] = value;
        this.setState({messageToBeSent});
    }

    addMessage = async () => {
        let selectedMsg =  {
            id: 0,
            agency_location: this.props.agencyLocation,
            message_category: 0,
            message: ''
        }
        try {
            let result = await StaffDataService.getMessageCategory();
            if (200 === result.status) {
                let categoryList = result.data.map(category => ({...category}));
                this.setState({
                    isAddClicked: true, isEditClicked: false, selectedMsg, categoryList
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    editMessage = async () => {
        try {
            let result = await StaffDataService.getMessageCategory();
            if (200 === result.status) {
                let categoryList = result.data.map(category => ({...category}));
                this.setState({isAddClicked: false, isEditClicked: true, categoryList});
            }
        } catch (error) {
            console.log(error);
        }
    }

    // Handle change event during adding/editing message.
    handleChange = (event) => {
        let name = event.currentTarget.name;
        let value = event.currentTarget.value;
        let selectedMsg = {...this.state.selectedMsg};
        selectedMsg[name] = value;
        this.setState({selectedMsg});
    }

    saveMessage = async (e) => {
        e.preventDefault();
        let selectedMsg = {...this.state.selectedMsg};
        let validationStatus = this.validator.validateForm(selectedMsg);
        if (!validationStatus.isValid) {
            this.setState((prevState) => ({
                errors: validationStatus.errors,
            }));
        } else {
            selectedMsg['message'] = selectedMsg['message'].trim();
            if (this.state.isAddClicked) {
                try {
                    await this.props.saveNewMessage(
                        this.props.agencyLocation, selectedMsg, 
                        this.props.staffData.messages
                    );
    
                } catch (error) {
                    toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
                    return false;
                }
            } else if (this.state.isEditClicked) {
                try {
                    await this.props.saveExistingMessage(
                        selectedMsg.id, selectedMsg, this.props.staffData.messages
                    );
                    
                } catch (error) {
                    toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
                    return false;
                }
            }
            toast.success("Saved Successfully.");
            selectedMsg['message'] = '';
            this.setState({
                isAddClicked: false, isEditClicked: false, selectedMsg, errors: {}
            });
        }
    }

    cancelSaveMessage = () => {
        let selectedMsg = {...this.state.selectedMsg};
        selectedMsg['message'] = '';
        this.setState({isAddClicked: false, isEditClicked: false, selectedMsg, errors: {}});
    }

    deleteMessage = async () => {
        let selectedMsg = {...this.state.selectedMsg};
        try {
            await this.props.deleteExistingMessage(
                selectedMsg.id, this.props.staffData.messages
            );
            toast.success("Deleted Successfully.");
            selectedMsg = {
                id: 0,
                message_category: 0,
                message: ''
            };
            this.setState({
                isAddClicked: false, isEditClicked: false, selectedMsg, errors: {}
            });
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            return false;
        }
    }

    // Check/uncheck staff check box
    toggleUserCheck = (event) => {
        let userList = {...this.state.userList};
        userList[event.currentTarget.value] = event.currentTarget.checked;
        // current user is always selected
        userList[this.props.selectedUser.id] = true;
        this.setState({userList});
    }

    // Check/uncheck all staff check box
    selectAllToggle = (event) => {
        let {userMasterList} = this.state;
        let userList = {...this.state.userList};
        let selectAll = !(this.state.selectAll);
        userMasterList.map((user) => {
            userList[user.id] = selectAll;
        });
        userList[this.props.selectedUser.id] = true;
        this.setState({userList, selectAll});
    }

    sendMessage = async () => {
        let {userMasterList} = this.state;
        let userList = {...this.state.userList};
        let messageToBeSent = {...this.state.messageToBeSent};
        let selectedUser = {...this.props.selectedUser};
        if (messageToBeSent.message.trim()) {
            messageToBeSent['user'] = selectedUser.id;
            let userListFinal = [];
            userMasterList.filter(user => {
                if (userList[user.id]) {
                    userListFinal.push(user.id);
                }
            });
            messageToBeSent['user_list'] = userListFinal;
            try {
                let result = await StaffDataService.postMessageSentItem(messageToBeSent);
    
                if (201 === result.status) {
                    toast.success("Sent Successfully.");
                    this.toggleModal();
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
                return false;
            }
        } else {
            toast.error("Please select a message from select box or enter your own text.");
        }        
    }

    toggleModal = () => {
        this.setState({
            selectedMsg: {
                id: 0,
                message_category: 0,
                message: ''
            },
            messageToBeSent: {
                user_list: [],
                user: 0,
                message: '',
            }
        }, () => this.props.toggleModal());
    };


    render() {
        const {
            isLoading, selectedMsg, messageToBeSent, isAddClicked, userMasterList,
            isEditClicked, selectAll, categoryList, errors, userList
        } = this.state;
        let messageListOption = [], categoryListOption = [];

        if (!(isEmpty(this.props.staffData))) {
            const {messages} = this.props.staffData;
            if (messages && messages.length) {
                messageListOption = messages.map((msg, index) =>
                    <option key={index} value={msg.id}>{msg.message}</option>
                );
            }
        }
            
        let userListOption = userMasterList.map((list, index) =>
            <div className="col-sm-6" key={index}>
                <div className="mb-2 form-check">
                    <label className="form-check-label position-relative">
                        <Input type="checkbox" className="form-check-input my-0" 
                            value={list.id} checked={userList[list.id]} 
                            onChange={this.toggleUserCheck} /> &nbsp; 
                        {list.full_name}
                    </label>
                </div>
            </div>
        );

        categoryListOption = categoryList.map((category, index) =>
            <option key={index} value={category.id}>{category.category}</option>
        );
                
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="lg">
                <ModalHeader toggle={this.toggleModal}>
                    Message To Staff
                </ModalHeader>
                <ModalBody>
                    <div className="row mb-3">
                        <div className="col-9">
                            <select name="message_item" className="form-control"
                                    onChange={this.msgChangeHandler}
                                    value={selectedMsg.id ? selectedMsg.id : 0}>
                                <option value="0">Select a Message</option>
                                {messageListOption}
                            </select>
                        </div>
                        <div className="col-3 pt-2">
                            <span className="cursor-pointer text-success pr-3" 
                                onClick={this.addMessage}
                            ><i className="fa fa-plus"></i> Add</span>
                            {selectedMsg.id > 0 ? 
                                <React.Fragment>
                                    <span className="cursor-pointer text-warning pr-3" 
                                        onClick={this.editMessage}
                                    ><i className="fa fa-pencil"></i> Edit</span>
                                    <span className="cursor-pointer text-danger" 
                                        onClick={this.deleteMessage}
                                    ><i className="fa fa-trash"></i> Delete</span>
                                </React.Fragment>
                                : null
                            }
                        </div>
                        {isAddClicked || isEditClicked ? 
                            <div className="col-12 mt-3">
                                <fieldset className="card card-body pt-1">
                                    <legend className="mb-0 pb-1" 
                                        style={{width:"fit-content"}}
                                    ><small><small>
                                        {isAddClicked ? 
                                            "Add New Message" 
                                            : isEditClicked ? 
                                                "Edit Message" 
                                                : ''
                                        } 
                                    </small></small></legend>
                                    <form>
                                    <div className="row">
                                        <div className="col-sm-4 col-md-3">
                                            <label className="mb-1">Message Category</label>
                                            <select name="message_category" 
                                                className="form-control" 
                                                onChange={this.handleChange} 
                                                value={selectedMsg.message_category}
                                            >
                                                <option value="0">Select a Category</option>
                                                {categoryListOption}
                                            </select>
                                            {errors.message_category ? 
                                                <span className="span-error"> 
                                                    {errors.message_category}
                                                </span> 
                                            : ''}
                                        </div>
                                        <div className="col-sm-8 col-md-9">
                                            <label className="mb-1">Message</label>
                                            <Input type="text" value={selectedMsg.message} 
                                                className="form-control" name="message" 
                                                onChange={(event) => this.handleChange(event)}/>
                                            {errors.message ? 
                                                <span className="span-error"> 
                                                    {errors.message}
                                                </span> 
                                            : ''}
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-6 col-sm-2">
                                            <Button type="submit" 
                                                className="btn btn-success btn-block" 
                                                onClick={this.saveMessage}
                                            >Save</Button>
                                        </div>
                                        <div className="col-6 col-sm-2">
                                            <Button className="btn btn-warning btn-block" 
                                                onClick={this.cancelSaveMessage}
                                            >Cancel</Button>
                                        </div>
                                    </div>
                                    </form>
                                </fieldset>
                            </div>
                            : null 
                        }
                        <div className="col-12 mt-3">
                            <Input type="textarea" className="form-control" rows="3" 
                                value={messageToBeSent.message} 
                                onChange={this.msgTextChangeHandler} 
                                placeholder="Select a message from above or enter your own message here." />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="bg-white px-3 py-2 max-height-300">
                                <label>Send To</label>
                                <div className="mb-2 form-check">
                                    <label className="form-check-label position-relative">
                                        <Input type="checkbox" 
                                            className="form-check-input my-0" 
                                            value={selectAll}  checked={selectAll} 
                                            onChange={this.selectAllToggle} 
                                        /> &nbsp; All
                                    </label>
                                </div>
                                <div className="row">
                                    {userListOption}
                                </div>
                            </div>
                        </div>
                    </div>
                    {isLoading && <LoadingModal modal={isLoading} />}
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-success' onClick={this.sendMessage}>
                        Send
                    </Button>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffData/MessageModal.js